// Publisher connector helpers — extracted so /publisher (a component file)
// stays free of non-component exports, which would trip react-refresh.
//
// `isConnectorLive` is the single source of truth for "show the Push button
// on /publisher" vs "render the 'Adapter coming' label." It derives from
// PUBLISHING_REGISTRY so this stays correct any time the registry flips.

import { PUBLISHING_REGISTRY, type PublishingDestinationKey } from "@/lib/publishingRegistry";
import type { ContentPublishingConnector } from "@/lib/composerCore";

// The DB `connector_type` enum uses `webhook` for the generic webhook
// adapter; the registry uses `generic_webhook`. Every other type matches 1:1.
export const connectorTypeToRegistryKey = (t: string): PublishingDestinationKey | null => {
  const key = t === "webhook" ? "generic_webhook" : t;
  return key in PUBLISHING_REGISTRY ? (key as PublishingDestinationKey) : null;
};

export const isConnectorLive = (c: ContentPublishingConnector) => {
  if (c.status !== "active") return false;
  const key = connectorTypeToRegistryKey(c.connector_type);
  if (!key) return false;
  const entry = PUBLISHING_REGISTRY[key];
  return entry.status === "live" && entry.surfaces.includes("long_form");
};

export const isConnectorUnofficial = (c: ContentPublishingConnector) => {
  const key = connectorTypeToRegistryKey(c.connector_type);
  return key ? PUBLISHING_REGISTRY[key].unofficial : false;
};
